import React,{Component} from 'react';

import {
  Card,
  CardBody,
  Popover,
  PopoverBody
} from 'reactstrap';

import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import InformationSVG from '../../../shared/assets/information.svg';

import {
  formatDateRange,
  timeForEngagements,
  humanReadableTime,
  costPerCompletion
} from '../../../shared/utils';

class CampaignOverview extends Component {
  constructor(){
    super();

    this.state = {
      isShowingReachPopover:false
    }
  }

  render(){
    const { activeCampaign, activeEngagements } = this.props;

    const { isShowingReachPopover } = this.state;

    const reachDenominator = costPerCompletion(activeCampaign,activeEngagements),
      reachNumerator = activeCampaign.lifetimeBudget,
      reach = Math.round(reachDenominator > 0 ? reachNumerator/reachDenominator : 0);

    return (
      <Card>
        <CardBody>
          <h3>
            Budget & Reach
            &nbsp;&nbsp;
            <img
              alt='Budget and Reach Information'
              src={InformationSVG}
              id='BudgetAndReachInfoIcon'
              onMouseEnter={() => this.setState({isShowingReachPopover:true})}
              onMouseLeave={() => this.setState({isShowingReachPopover:false})}
            />
            <Popover
              className='TooltipPopover'
              isOpen={isShowingReachPopover}
              target='BudgetAndReachInfoIcon'
              placement='left'
            >
              <PopoverBody>
                Guaranteed consumer reach when budget is met.
              </PopoverBody>
            </Popover>
          </h3>
          <div>
            <strong>{activeEngagements.length || 0} - activity experience</strong>
          </div>
          <div>
            <strong><MoneyDisplay>{activeCampaign.lifetimeBudget || 0}</MoneyDisplay> budget</strong>
          </div>
          <div>
            <strong>{humanReadableTime(timeForEngagements(activeEngagements))}</strong>
            <br />
            <small className="text-muted">Estimated time spent per consumer</small>
          </div>
          <div>
            <strong><MoneyDisplay>{activeCampaign.costPerCompletion}</MoneyDisplay></strong>
            <br />
            <small className="text-muted">Cost per completion</small>
          </div>
          <div>
            <strong>{(isNaN(reach) ? 0 : reach).toLocaleString()} consumers</strong>
            <br />
            <small className="text-muted">Reach</small>
          </div>
          {activeCampaign.launchDate && activeCampaign.endDate && (
            <strong>
              {formatDateRange(activeCampaign.launchDate,activeCampaign.endDate,'to')}
            </strong>
          )}
          {activeCampaign.launchDate && (!activeCampaign.endDate) && (
            <strong>
              Starts {formatDateRange(activeCampaign.launchDate)}
            </strong>
          )}
        </CardBody>
      </Card>
    )
  }
}

export default CampaignOverview



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignPayment/components/CampaignOverview.js